<template>
    <div id="operations">
        <ErrorMessages :errors="errors" :description="$t('ui.general.error')" :is_closable="true"></ErrorMessages>

        <Filters></Filters>

        <div class="ui segment">
            <div v-if="style.width < 767" style="margin-bottom: 1em;">
                <div v-if="is_loading">
                    <div class="ui active centered inline loader"></div>
                </div>
                <DataCard
                    v-else
                    v-for="operation in operations"
                    :key="operation.identity"
                    :object="operation"
                    :title="operation.number"
                    :title_link="{name: 'show_customer_operation', params: {identity: operation.identity}}"
                    :date="human_datetime(operation.created_at)"
                    :sub_title="data_card_sub_title(operation)"
                    :color="data_card_color(operation)"
                    :is_show_column="true"
                    :keys="['your_note','file']"
                    :i_18n_key="'operations'"
                >
                    <span slot="your_note" v-if="operation.customer_note">
                        {{ operation.customer_note }}
                    </span>
                    <a slot="file" :href="operation.original_file_url">
                        {{ operation.original_file_name }}
                    </a>
                </DataCard>

                <div v-if="!is_loading && operations.length <= 0"
                    class="ui center aligned red segment">
                    <h3>
                        {{ $t('ui.general.no_data') }}
                    </h3>
                </div>
            </div>
            <table v-else class="ui compact celled table">
                <thead class="center aligned">
                    <tr>
                        <th>{{ $t('ui.general.date') }}</th>
                        <th>{{ $t('models.attributes.operations.number') }}</th>
                        <th>{{ $t('models.attributes.operations.your_note') }}</th>
                        <th>
                            {{ $t('ui.pages.operations.table.finish') }}/
                            {{ $t('ui.pages.operations.table.total') }}
                        </th>
                        <th>{{ $t('models.attributes.operations.status') }}</th>
                        <th>{{ $t('models.attributes.operations.file') }}</th>
                        <th>{{ $t('ui.general.operate') }}</th>
                    </tr>
                </thead>
                <tbody v-if="is_loading" class="center aligned">
                    <tr class="loading">
                        <td colspan="7">
                            <div class="ui active centered inline loader"></div>
                        </td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <Operation
                        v-for="operation in operations"
                        :key="operation.identity"
                        :operation="operation"
                    ></Operation>
                    <tr v-if="operations.length <= 0" class="center aligned">
                        <td colspan="7" >
                            <h5>{{ $t('ui.general.no_data') }}</h5>
                        </td>
                    </tr>
                </tbody>
            </table>

            <Paginator
                v-if="operations.length > 0"
                :total_pages="pagination.total_pages"
                :current_page="pagination.current_page"
                :disabled="is_loading"
            />
        </div>

    </div>
</template>

<script>
import Filters from "../.components/customer/filter/main.vue"
import Operation from "../.components/customer/index/item.vue"
import Paginator from '@toolbox/pagination/paginator.vue'
import ErrorMessages from '@toolbox/error_box/main.vue'
import DataCard from '@toolbox/data_card/main.vue'

export default {
    name: "CustomerOperationsIndex",
    data() {
        return {
            is_initialized: false,
            is_loading: false,
            is_search_params_changed: false,
            errors: [],
        }
    },
    computed: {
        style() {
            return this.$store.state.style
        },
        current_store() {
            return this.$store.state.customer.operations_module
        },
        operations() {
            return this.current_store.operations
        },
        pagination() {
            return this.current_store.pagination
        },
    },
    created() {
    },
    mounted() {
        this.init()

        this.$bus.$off('init')
        this.$bus.$on('init', (value = false) => {
            this.init()
        })
    },
    beforeDestroy() {
        this.$bus.$off('init')
        this.pagination.current_page = 1
    },
    watch: {
        '$route'(to, from) {
            this.init(false)
        },
    },
    methods: {
        async init(is_first = true) {
            try {
                await new Promise(resolve => {
                    this.errors = []
                    this.is_initialized = false
                    this.is_loading = true
                    resolve()
                })
                await this.$store.dispatch('customer/operations_module/handle_query_to_filter',{
                    query: this.$route.query
                })
                if (is_first) {
                    await this.$store.dispatch('customer/operations_module/handle_quick_filter_key')
                }
                await this.$store.dispatch('customer/operations_module/fetch_operations')
            } catch (e) {
                console.log("init error: ")
                console.log(e)
                this.$noty.error(
                    this.$t('ui.notifications.error.fetch__name', {
                        name: this.$t('models.operations'),
                        reason: e
                    })
                )
                this.errors.push(e)
            } finally {
                this.is_initialized = true
                this.is_loading = false
            }
        },
        operations_filter() {
            console.log('operations_filter')
            try {
                this.$router.push({
                    name: this.$router.name,
                    query: this.$store.getters['customer/operations_module/filter_to_query'],
                })
            } catch (e) {
                console.log(e)
            }
        },
        data_card_sub_title(operation) {
            return this.done_core_waybills(operation).length + ' / ' + operation.core_waybills.length + ' ' + this.status(operation)
        },
        data_card_color(operation) {
            if (operation.core_waybills.length == 0) {
                return 'red'
            }
            if (operation.core_waybills.length != 0 && operation.core_waybills.length == this.done_core_waybills(operation).length) {
                return 'green'
            }
        },
        done_core_waybills(operation) {
            return _.filter(operation.core_waybills, (core_waybill) => {
                return core_waybill.is_done == true
            })
        },
        status(operation) {
            if (operation.is_canceled) {
                return this.$t('models.attributes.operations.is_canceled')
            }
            if (operation.is_done) {
                return this.$t('models.attributes.operations.is_canceled')
            }
            return this.$t('ui.pages.operations.processing')
        },
    },
    components: {
        Operation,
        Paginator,
        DataCard,
        ErrorMessages,
        Filters,
    }
}
</script>
<style scoped>
#operations {
    /*overflow-x: auto;*/
}
</style>
